// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"826c54b4","239":"cab9eb10","453":"d3e8db46","455":"3a454819"}[chunkId] + ".chunk.js";
};